import Model from 'model/model'

export default Model.extend({
    defaults: {
        index: 0,
    },
})
